var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductNameContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255,
    height: 137,
    viewBox: "0 0 255 137",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 137,
    rx: 10,
    fill: "url(#paint0_radial_0_2333)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_2333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 255,
    height: 137
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 137,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_2333)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.765433,
    filter: "url(#filter0_f_0_2333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -0.5,
    cy: -40.5,
    r: 96,
    fill: "#7AD8FB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_2333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 304.5,
    cy: 137.5,
    r: 96,
    fill: "#FBB57A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_2333",
    x: -186.203,
    y: -226.203,
    width: 371.407,
    height: 371.407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.8517,
    result: "effect1_foregroundBlur_0_2333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_2333",
    x: 118.797,
    y: -48.2033,
    width: 371.407,
    height: 371.407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.8517,
    result: "effect1_foregroundBlur_0_2333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_2333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-270.068 176.57 -328.651 -145.095 264.945 -14.2296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.530886,
    stopColor: "#A337F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A7ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductNameContainer);
export default __webpack_public_path__ + "static/media/product_name_container.5a2f729e67248edd284764d6012da114.svg";
export { ForwardRef as ReactComponent };